import axios from "axios";
import UserService from "rc-app/services/UserService";

/**
 * @param {string} agencyId
 * @param {number} [page]
 * @param {number} [limit]
 * @param {string | null} [startDate]
 * @param {string | null} [endDate]
 * @param {string | null} [agentId]
 * @param {string | null} [clientAdminId]
 * @param {string | null} [clientManagerId]
 */
export const getVrSessionList = async (
  agencyId,
  page = 0,
  limit = 20,
  startDate = null,
  endDate = null,
  agentId = null,
  clientAdminId = null,
  clientManagerId = null,
) => {
  try {
    let API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/vr/sessions?agency_id=${agencyId}&page=${page}&limit=${limit}`;

    // Add date filters if provided
    if (startDate) {
      API_URL += `&start_date=${startDate}`;
    }
    if (endDate) {
      API_URL += `&end_date=${endDate}`;
    }
    if (agentId) {
      API_URL += `&agent_id=${agentId}`;
    }
    if (clientAdminId) {
      API_URL += `&asa_id=${clientAdminId}`;
    }
    if (clientManagerId) { // Fixed: was clientAdminId
      API_URL += `&aba_id=${clientManagerId}`; // Fixed: use clientManagerId
    }

    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching VR sessions:", error);
    return [];
  }
};


// export const createAgent = async (jsonData) => {
//   try {
//     console.log("create Client", jsonData);

//     const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agent`;
//     const PAYLOAD = {
//       ...jsonData,
//     };

//     const response = await axios.post(API_URL, PAYLOAD, {
//       headers: {
//         Authorization: `Bearer ${UserService.getToken()}`,
//         "ngrok-skip-browser-warning": "disabled",
//         "Content-Type": "application/json",
//       },
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error fetching gender options:", error);
//     throw error;
//   }
// };

// export const updateAgent = async (jsonData, agentId) => {
//   try {
//     const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agent/${agentId}`;
//     const PAYLOAD = {
//       ...jsonData,
//     };

//     const response = await axios.put(API_URL, PAYLOAD, {
//       headers: {
//         Authorization: `Bearer ${UserService.getToken()}`,
//         "ngrok-skip-browser-warning": "disabled",
//         "Content-Type": "application/json",
//       },
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error fetching gender options:", error);
//     throw error;
//   }
// };
